/* Kolsyra sticky header - liquid glass on scroll.
 * Always visible. Toggles .is-scrolled when user has scrolled past 10px,
 * which CSS uses to flip the pill from solid white to liquid glass
 * (translucent + backdrop-filter blur). rAF-throttled, passive listener,
 * no dependencies. */
(function () {
  'use strict';

  const header = document.querySelector('.k-header');
  if (!header) return;

  const TOP_GATE = 10;
  const SCROLLED_CLASS = 'is-scrolled';
  const menuToggle = header.querySelector('.k-header__menu-toggle');
  const mobileMenu = header.querySelector('.k-mobile-menu');
  const mobileMenuClose = header.querySelector('.k-mobile-menu__close');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let ticking = false;
  let lastFocusedElement = null;

  function update() {
    if (window.scrollY >= TOP_GATE) {
      header.classList.add(SCROLLED_CLASS);
    } else {
      header.classList.remove(SCROLLED_CLASS);
    }
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );

  // Run once on load so deep-linked scroll positions get the right state.
  update();

  if (!menuToggle || !mobileMenu) return;

  function getFocusableElements() {
    return Array.from(mobileMenu.querySelectorAll(focusableSelector)).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function openMenu() {
    lastFocusedElement = document.activeElement;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.classList.add('is-active');
    menuToggle.setAttribute('aria-expanded', 'true');
    menuToggle.setAttribute('aria-label', 'Stäng meny');
    document.body.classList.add('k-menu-open');
    const focusableElements = getFocusableElements();
    if (focusableElements.length) {
      focusableElements[0].focus();
    }
  }

  function closeMenu(options) {
    const shouldRestoreFocus = !options || options.restoreFocus !== false;

    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle.classList.remove('is-active');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', 'Öppna meny');
    document.body.classList.remove('k-menu-open');

    if (shouldRestoreFocus && lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  menuToggle.addEventListener('click', function () {
    if (mobileMenu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function () {
      closeMenu();
    });
  }

  mobileMenu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      closeMenu({ restoreFocus: false });
    });
  });

  document.addEventListener('keydown', function (event) {
    if (!mobileMenu.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeMenu();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });
})();
